<template>
  <scroll-bar>
    <div
      class="navbar-logo"
      v-if="showSidebar"
      :style="{width:!isCollapse ? '220px' : '0', paddingLeft: !isCollapse ? '20px' : '0'}"
    >
      <el-image class="logo" :src="logo" @click="openHome"></el-image>
      <P class="companyName" @click="openHome">
        {{$t("ums.seller")}}  ·  {{ companyName }}
      </P>
    </div>
<!--  占位  -->
    <div class="navbar-logo2" v-if="!isCollapse && showSidebar"></div>
<!--    <div :class="isCollapse ? 'collapse-logo' : 'sidebar-logo'">-->
<!--      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>-->
<!--    </div>-->
    <el-menu
        v-debounce
        mode="vertical"
        :default-active="$route.path"
        :collapse="isCollapse"
        :background-color="'#203245'"
        :text-color="'#A8B5C4'"
        :active-text-color="'#ff6821'"
        :default-openeds="openMenu"
    >
      <!--   处理Home菜单   -->
      <template v-if="isCollapse">
        <el-submenu index="/">
          <template slot="title">
            <i class="fi fi-sr-dashboard svg-icon" style="font-size: 16px !important;"></i>
            <span slot="title">{{$t("system.home")}}</span>
          </template>
          <router-link v-debounce to="/home" @click.native.capture="resetPageCache">
            <el-menu-item index="Home">{{$t("system.home")}}</el-menu-item>
          </router-link>
        </el-submenu>
      </template>
      <template v-else>
        <router-link v-debounce :to="'/home'" :key="'home'" @click.native.capture="resetPageCache">
          <el-menu-item :index="'/home'">
            <i class="fi fi-sr-dashboard svg-icon" style="font-size: 16px !important;"></i>
            <span slot="title">{{$t("system.home")}}</span>
          </el-menu-item>
        </router-link>
      </template>

      <sidebar-item
          v-for="(route, index) in routers"
          :isCollapse="isCollapse"
          :key="route.path  + index"
          :item="route"
          :base-path="route.path"
      />
    </el-menu>
  </scroll-bar>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar';
import logo from "@/assets/logo/hurixWhite2.png";
import Hamburger from "@/components/Hamburger/index.vue";
import {navigateFromMenu} from '@/utils/pageNavigation'

export default {
  components: {Hamburger, SidebarItem, ScrollBar},
  props: {
    showSidebar: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    ...mapState({
      companyName: state => state.user.companyName,
    }),
    isCollapse() {
      return !this.sidebar.opened
    },
    // 检查当前路由是否在Home页
    checkIfHome() {
      return this.$route.path === '/home'
    }
  },
  watch: {
    routers: {
      handler(val) {
        if (!val) return;
        this.openMenu = val.filter(item => !item.hidden && item.children && item.children.length)
            .map(item => item.name);
      },
      immediate: true,
      deep: true,
    },
    isCollapse: {
      handler(val) {
        this.$emit('isCollapseChange', val)
      }
    },
    'sidebar.opened'(opened) {
      if (opened) {
        this.openAllMenus()
      }
    }
  },
  data() {
    return {
      logo,
      openMenu: []
    }
  },
  methods: {
    resetPageCache(event) {
      return navigateFromMenu(this.$router, this.$store, '/home', event)
    },
    openHome() {
      return this.resetPageCache()
    },
    openAllMenus() {
      this.$nextTick(() => {
        const menu = this.$refs.menu
        if (!menu || this.isCollapse) return
        this.routers
          .filter(item => !item.hidden && item.children && item.children.some(child => !child.hidden))
          .forEach(item => menu.open(item.name || item.path))
      })
    },
    // goHome() {
    //   this.$router.push('/home')
    // },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
      if (this.isCollapse && this.routers.length) return
      this.openMenu = this.routers.filter(item => !item.hidden && item.children && item.children.length)
          .map(item => item.name);
    }
  }
}
</script>
<style lang="scss" scoped>
.navbar-logo2 {
  height: 64px;
  padding-left: 20px;
  width: 220px;
  border-bottom: 1px solid transparent;
  margin-bottom: 20px;
}
.navbar-logo {
  padding: 10px 0 10px 20px;
  width: 220px;
  background: #203245;
  height: 64px;
  line-height: 22px;
  border-bottom: 1px solid #2a3a4f;
  box-shadow: rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0) 0 0 0 0, rgba(0, 0, 0, 0.05) 0 1px 2px 0;
  position: fixed;
  z-index: 1;
  top: 0;
  overflow: hidden;
  transition: width .28s;

  p {
    cursor: pointer;
  }

  .logo {
    width: 86px;
  }

  .companyName {
    font-size: 10px;
    color: #8b99a9;
  }
}
.collapse-logo {
  padding: 10px;
}

.sidebar-logo {
  position: absolute;
  right: 0;
  z-index: 99;
  padding: 13px;
}

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue